module.exports = __webpack_public_path__ + "img/1484397632.7cb708a9.jpg";